import React from "react";
import { FaMediumM , FaGithub, FaChevronCircleUp,
    FaLinkedin} from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll"
import {  FooterContainer, FooterWrap, SocialMedia, SocialMediaWrap, SocialLogo,
WebsiteRights,SocialIcons,SocialIconLink } from './FooterElements';
const Footer = () => {
    const toggleHome = () => {
        scroll.scrollToTop();
    }
    return(
        <FooterContainer>
            <FooterWrap>
                <SocialMedia>
                <SocialMediaWrap>
                    <SocialLogo to = '/'
                    onClick = {toggleHome}><FaChevronCircleUp/></SocialLogo>
                    <WebsiteRights>
                    Built with ♥ by Kiran &ensp; | © {new Date().getFullYear()}
                     </WebsiteRights>
                    <SocialIcons>
                        <SocialIconLink href = 'https://medium.com/@kiranjolisa' target = '_blank'
                        aria-label = "Medium">
                            <FaMediumM />
                        </SocialIconLink>
                        <SocialIconLink href = 'https://github.com/kiranjolisa' target = '_blank'
                        aria-label = "GitHub">
                            <FaGithub/>
                        </SocialIconLink>
                        <SocialIconLink href = 'https://www.linkedin.com/in/kiran-r-6b0124152/' target = '_blank'
                        aria-label = "LinkedIn">
                            <FaLinkedin />
                        </SocialIconLink>
                    </SocialIcons>
                </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>
        </FooterContainer>
    )
}

export default Footer;